import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

function IndustryHeroPremium() {
  const navigate = useNavigate();

  return (
    <section className="industries-hero-premium">

      <div className="industries-hero-container">

        <motion.div
          className="industries-hero-content"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: .8 }}
        >

          <span className="industry-kicker">
            INDUSTRY EXPERTISE
          </span>

          <h1>
            Industry Expertise
            <br />
            Designed Around Growth.
          </h1>

          <p>
            We help healthcare organizations,
            educational institutions, real estate
            firms, ecommerce brands and SaaS
            companies build measurable growth
            systems powered by strategy,
            marketing, technology and AI.
          </p>

          <div className="industry-hero-actions">

            <button
              className="primary-button"
              onClick={() => navigate("/contact")}
            >
              Book Strategy Call
            </button>

            <button
              className="industry-link-btn"
              onClick={() => navigate("/free-growth-audit")}
            >
              Free Growth Audit
              <ArrowRight size={18} />
            </button>

          </div>

          <div className="industry-proof-strip">

            <div>
              <strong>Growth</strong>
              <span>Strategy</span>
            </div>

            <div>
              <strong>Marketing</strong>
              <span>Execution</span>
            </div>

            <div>
              <strong>Technology</strong>
              <span>Platforms</span>
            </div>

            <div>
              <strong>AI</strong>
              <span>Automation</span>
            </div>

          </div>

        </motion.div>

        <motion.div
          className="industry-hero-visual"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >

          <div className="industry-glass-panel">

            <div className="industry-glass-header">
              Growth Systems
            </div>

            <div className="industry-metrics-grid">

              <div>
                <span>Healthcare</span>
                <strong>Patient Growth</strong>
              </div>

              <div>
                <span>Education</span>
                <strong>Admissions</strong>
              </div>

              <div>
                <span>Real Estate</span>
                <strong>Lead Flow</strong>
              </div>

              <div>
                <span>SaaS</span>
                <strong>Pipeline</strong>
              </div>

            </div>

          </div>

        </motion.div>

      </div>

    </section>
  );
}

export default IndustryHeroPremium;